import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'
import { Client } from '.'

class Postier {
    createClient(token: string, data, setLoading, setErrors: Dispatch<SetStateAction<string[]>>) { 
        axios.post(`api-v0/NewClient`,data, { headers: { Authorization: `Bearer ${token}` }})
        .then(res=>{
            if (res.data) {
                setLoading(false)
                setErrors((errors: string[]) => [...errors, 'Client créé'])
            }
        }).catch(err=>{
            setLoading(false)
            setErrors((errors: string[]) => [...errors, err.response.data])
        }) 
    } 

    getClient(token: string, database: string, setClient: Dispatch<SetStateAction<Client>>, setErrors: Dispatch<SetStateAction<string[]>>) { 
        axios.get(`api-v0/client/${database}`, { headers: { Authorization: `Bearer ${token}` }})
        .then(res=>{
                setClient(res.data)
            
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, err.response.data])
        }) 
    } 
}

export const postier = new Postier()
